export default __webpack_public_path__ + "static/media/visa.7e2e09f9.svg";